module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":{"employer":"The Sponsor Licence service has been started. If you want to amend Sponsor Licence data, go to Services and find that service in the chart."}}}')
  delete Component.options._Ctor
}
